const styles = theme => ({
    root: {
        backgroundColor: "transparent",
    },
    gutters:{
        paddingRight:"0px",
        paddingLeft:"0px",
    },
    grow: {
        flexGrow: 1,
        textAlign:"center"
    },
    wrongEnvironmentWarning:{
        fontSize:"12px",
        color:theme.ErrorMessageColor,
        fontWeight:"bold",
        [theme.breakpoints.down('md')]: {
            fontSize:"10px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"8px",
        },
    },
    hideWarning:{
        display:"none"
    },
    prodLink:{
        color:theme.commonAppHeaderTabColor,
        textDecoration:"underline",
        '&:hover':{
            opacity:"0.7",
            cursor:"pointer",
        }
    },
    tabsRoot: {
        marginLeft: "20px",
        [theme.breakpoints.down('md')]: {
            marginLeft: "5px",
        }
    },
    headerStyles: {
        backgroundColor: theme.HeaderBGColor,
        height: "46px"
    },
    tabRoot: {
        textTransform: "initial",
        fontSize: "14px",
        color: theme.HeaderDefaultTextColor,
        fontWeight: "600",
        "&$tabSelected": {
            color: theme.commonAppHeaderTabColor,

        },
        '&:hover': {
            color: theme.commonAppHeaderTabColor,
            opacity: 1,
        },
        [theme.breakpoints.down('md')]: {
            fontSize:"12px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"9px"
        }
    },
    tabsIndicator: {
        backgroundColor: theme.commonAppHeaderTabColor,
        height: "4px"
    },
    tabSelected: {},
    headerIcons: {
        height: "100%",
        padding: "6px 0",
        boxSizing: "border-box",
        color: theme.headerIconColor,
        '& div': {
            float: "left"
        },
    },
    headerIconStyles: {
        height: "32px",
        boxSizing: "border-box",
        cursor: "pointer",
        color: theme.headerIconColor,
        '&:hover': {
            color: theme.commonAppHeaderTabColor,
        },
    },
    refreshContainer: {
        padding:"0 16px 0 8px",
        [theme.breakpoints.down('md')]: {
            padding:"0px"
        }
    },
    refreshIconContainer:{
        paddingTop: "8px",
        paddingRight:"8px"
    },
    refreshText: {
        float: "left",
        fontSize: "9px",
        fontWeight: "600",
        display: "flex",
        flexDirection: "column",
        lineHeight: "13px",
        paddingRight: "8px",
        height: "100%",
        cursor : "pointer"
    },
    planDate:{
        fontSize:theme.textFontSize,
        color:"white",
        letterSpacing:"0.05em",
        [theme.breakpoints.down('md')]: {
            fontSize:"9px"
        },
    },
    scenarioDetail:{
        lineHeight: "24px"
    },
    optymizeBtnContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "0px 15px",
        [theme.breakpoints.down('md')]: {
            border:"0px"
        }
    },
    optymizeButtonStyle: {
        padding: "4px 6px",
        width: "125px",
        fontWeight: "bold",
        height: "32px",
		borderRadius: "2px",
		'&$disabledOptymizeBtn':{
			 color: "white",
			 fontWeight: "bold",
			 height: "32px",
			 borderRadius: "2px",
			 opacity: "0.4",
			 cursor: "not-allowed",
			//  pointerEvents: "auto",
			 background: theme.commonAppHeaderTabColor,
			 '&:hover':{
				 background: theme.commonAppHeaderTabColor,
				 opacity: "0.4"
			 }
		 },
    },
    disabledOptymizeBtn:{},
    terminalIconStyle: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "9px 0px 9px 5px",
        fontSize: "14px",
        fontWeight:"bold",
        color:theme.commonAppHeaderTabColor,
        width:"72px",
        textAlign:"center",
        '&:hover': {
            opacity: "0.7"
        },
    },
    publishIconContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
        padding: "5px 15px"
    },
    publishIconStyle: {
        border: `1px solid ${theme.commonAppHeaderTabColor}`,
        padding: "2px",
        borderRadius: "2px",
        color: theme.commonAppHeaderTabColor,
        '&:hover': {
            opacity: "0.7"
        },
    },
    publishLoaderStyle: {
        border: `1px solid ${theme.commonAppHeaderTabColor}`,
        padding: "4px",
        borderRadius: "2px",
        color: theme.commonAppHeaderTabColor,
    },
    disabledPublishIcon: {
        border: `1px solid ${theme.commonAppHeaderTabColor}`,
        padding: "2px",
        borderRadius: "2px",
        color: theme.commonAppHeaderTabColor,
        cursor:"not-allowed",
        opacity: "0.5"
    },
    muiIconContainer: {
        borderLeft: `1px solid ${theme.headerBorderColor}`,
    },
    muiIconButtonStyle: {
        padding: "9px 15px"
    },
    paper: {
        background: theme.ModalBGColor,
        borderRadius: "0px 0px 4px 4px",
        width: "291px",
        padding: "2px",
        marginTop: "10px",
        overflow: "visible"
    },
    placementRight: {
        maxWidth: "199px",
    },
    moduleSwitcher:{
        fontSize:"17px",
        color:theme.HeaderDefaultTextColor,
        [theme.breakpoints.down('md')]: {
            fontSize:"14px"
        },
        [theme.breakpoints.down('sm')]: {
            fontSize:"11px"
        }
    },
    toggledMenu:{
        display:"none",
        '@media (max-width: 1400px)': {
            display:'block'
        }
    },
    mainMenu:{
        background: theme.HeaderBGColor,
        borderRadius: "0px 0px 4px 4px",
        marginTop: "30px",
        overflow: "visible",
        display:'none',
        '@media (max-width: 1400px)': {
            display:'block'
        }
    },
    mainMenuStyle:{
        display:"block",
        padding:"12px 0px",
        width:"364px",
        '@media (min-width: 1400px)': {
            display:"initial",
            padding:"initial",
            width:"initial",
        }
    },
    rmaxLogo:{
        height: "15px",
        [theme.breakpoints.down('md')]: {
            width:"90px"
        }
    },
    shipmentSelectionRmaxLogo : {
        height: "15px",
        padding:"12px",
        [theme.breakpoints.down('md')]: {
            width:"90px"
        }
    },
    mainMenuButton:{
        padding:"9px",
        color:theme.commonAppHeaderTabColor
	},
	disabledCursor:{
		cursor:"not-allowed"
	},
    proDetailsPanel : {
        position : "absolute",
        left : "auto"
    },
    optimyzerWatchTutorial : {
        padding: 8,
		borderRadius: "2px",
        fontWeight: "bold",
        background: theme.commonAppHeaderTabColor,
        color : theme.white
    },
    rightNavMenuContainer : {
        '@media (max-width: 1400px)': {
            display:'none'
        }
    }
});

export default styles;